import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sendAdminForm } from '@entities/adminConversationUserHistory/api/handlers/sendAdminForm';

export function useSendAdminFormQuery() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: sendAdminForm,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['adminForm'] });
        },
    });
}
